import { render, staticRenderFns } from "./FormDigitalCases.vue?vue&type=template&id=724aa30c&lang=pug&"
import script from "./FormDigitalCases.vue?vue&type=script&lang=js&"
export * from "./FormDigitalCases.vue?vue&type=script&lang=js&"
import style0 from "./FormDigitalCases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports